import React from 'react';
import InfoTooltip from '../../../components/InfoTooltip/InfoTooltip';

/**
 * A card with an icon + title header, optional "i" popover and a right-hand slot — the
 * gateway page's `gw-card` shell, reused so the battery page reads like its neighbours.
 */
export const Panel = ({ icon, title, info, right, children, className = '' }) => (
    <div className={`gw-card ${className}`.trim()}>
        <div className="gw-card__header">
            <span className="gw-card__header-title">
                {icon ? <i className={`fa-solid ${icon}`} /> : null} {title}
                {info ? <InfoTooltip tooltip={info} className="vb-panel__info" /> : null}
            </span>
            {right ? <span className="gw-card__header-meta vb-panel__right">{right}</span> : null}
        </div>
        {children}
    </div>
);

/**
 * Label over a value with an optional unit and sub-line. `tone` colours the value: `warn` /
 * `bad` for a figure that reads as fine but is not.
 */
export const StatTile = ({ label, value, unit, hint, tone, info }) => (
    <div className="vb-tile">
        <span className="vb-tile__label">
            {label}
            {info ? <InfoTooltip tooltip={info} className="vb-tile__info" /> : null}
        </span>
        <span className={`vb-tile__value${tone ? ` vb-tile__value--${tone}` : ''}`}>
            {value}
            {unit ? <span className="vb-tile__unit">{unit}</span> : null}
        </span>
        {hint ? <span className="vb-tile__sub">{hint}</span> : null}
    </div>
);

/** A label/value pair inside a panel grid — the gateway page's `gw-field`. */
export const Field = ({ label, value, mono, node }) => (
    <div className="gw-field">
        <span className="gw-field__label">{label}</span>
        <span className={`gw-field__value${mono ? ' gw-field__value--mono' : ''}`}>
            {node ?? (value === null || value === undefined || value === '' ? '—' : value)}
        </span>
    </div>
);
